const templateSignupSection = document.createElement('template');

templateSignupSection.innerHTML = `<section class="secondary-bg sign-up container mh-a t-c">
<span class="au-dot"></span>
  <h2 class="title">Excited to take up Courses?</h2>
  <a class="link link-btn signup"> Sign Up</a>
</section>`;
export default class LandingSignUp extends HTMLElement {
  connectedCallback() {
    this.appendChild(templateSignupSection.content.cloneNode(true));
    this._bindSignupClick();
  }

  _bindSignupClick() {
    this.querySelector('.signup').addEventListener('click', () => {
      window.location.href = `/signup?referrer=${window.location.href}`;
    });
  }
}
